import { useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setCustomFields } from "../../redux/slices/session"
import { RootState } from "../../redux/store"
import { CustomField } from "../../types/custom-fields/custom-field"
import { centsClient } from "../../api/cents/clients/cents-client"

export function useCustomFields(): { get: () => Promise<CustomField[]> } {
  const fields = useSelector((state: RootState) => state.auth.customFields)
  const dispatch = useDispatch()

  const get = useCallback(async () => {
    if (!fields) {
      const res = await centsClient.fields.get()
      dispatch(setCustomFields(res))
      return res
    } else {
      return fields
    }
  }, [fields, dispatch])

  return { get }
}